(() => {
  const initialise = (root) => {
    root.querySelectorAll('[data-bk-article]').forEach((article) => {
      const toc = article.querySelector('[data-bk-toc]');
      const content = article.querySelector('[data-bk-article-content]');
      if (!toc || !content || toc.dataset.ready) return;
      toc.dataset.ready = 'true';
      const headings = [...content.querySelectorAll('h2')];
      if (headings.length < 2) return;
      const list = toc.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = `article-section-${index + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      toc.hidden = false;
      if (matchMedia('(max-width:749px)').matches) toc.open = false;
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
